module.exports = __webpack_public_path__ + "img/ningweixi.3a533e9b.jpg";